import _ from 'lodash';

import { validatePatientCaregiver } from 'common-src/models/PatientCaregiver';

export const catchErrors = (data, isGuide) => {
  const errors = {};
  Object.entries(data).forEach(([field, value]) => {
    const err = validatePatientCaregiver(field, value, data, isGuide);
    if (err[field]) {
      Object.assign(errors, { [field]: err[field] });
    }
  });

  return {
    errors,
    hasErrors: !_.isEmpty(errors) || Object.values(errors).some((e) => e),
  };
};
